import './vee-validate.config';
import { App } from 'vue';
import inputConfig from './inputs/formInputs.config';

export default function config(app: App): void {
    inputConfig(app);
}
